function TabContentCtrl() {}
;
export default TabContentCtrl;